import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import moment from 'moment';

const mapPhoneLineToApiPhoneLineDto = (values: IEditPhoneLineForm, phoneLineId:number): IPostEditPhoneLine | {} => {
  let dataMapping: IPostEditPhoneLine;
  const unknown = -1;

    dataMapping = {
      id: phoneLineId,
      unitID: +values.unitID,
      applProtocolNumber: values.applProtocolNumber,
      applDate: values.applDate ? `${moment(values.applDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null ,
      offApplDate: values.offApplDate ? `${moment(values.offApplDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null  ,
      deliveryDate: values.deliveryDate ? `${moment(values.deliveryDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null  ,
      removalDate: values.removalDate ? `${moment(values.removalDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null ,
      comments: values.comments,
      sapCode: values.sapCode,
      phoneNumber: values.phoneNumber,
      lineType: 1,
      isEmporiki:values.isEmporiki,
      isCiti: values.isCiti,
      deleted: values.deleted,
      providerID: +values.providerID !== 0 ? +values.providerID : unknown,
      descline: values.descline
    }

    if (+values.pendingStatusID !== 0) {
      dataMapping.pendingStatusID = +values.pendingStatusID;
    }

    if (+values.usedByID !== 0) {
      dataMapping.usedByID = +values.usedByID;
    }

    if (+values.lineTypeID !== 0) {
      dataMapping.lineTypeID = +values.lineTypeID;
    }else{
      dataMapping.lineTypeID = null;
    }
/* 
    if (+values.providerID !== 0) {
      dataMapping.providerID = +values.providerID;
    }else{
      dataMapping.providerID = null;
    } */
  
  return dataMapping; 
}

const editPhoneLine = ( {data, phoneLineId} : {data: IEditPhoneLineForm, phoneLineId: number}): Promise<string> => {
  const phoneLine = mapPhoneLineToApiPhoneLineDto(data ,phoneLineId);
  return axiosDefaultApi.put(`/api/ComLines/UpdateComLine`, phoneLine);
};

type QueryFnType = typeof editPhoneLine;

type UseEditPhoneLineOptions = {
  data: IPostEditPhoneLine | {};
  phoneLineId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditPhoneLine = ({ config }: UseEditPhoneLineOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της τηλεφωνικής γραμμής.`, 500);
            console.error('Couldnt edit Phone line', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPhoneLines"])
            addNotification('Η τηλεφωνική γραμμή Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editPhoneLine,
    })
}